import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';

// Initialize Firebase, copy this from the cloud console
// Or use mine :)
var config = {
    apiKey: "AIzaSyA4Z8imGM9FAegc8b8rT5ABSi6lDvF0TSg",
    authDomain: "test-bc317.firebaseapp.com",
    databaseURL: "https://test-bc317.firebaseio.com",
    projectId: "test-bc317",
    storageBucket: "test-bc317.appspot.com",
    messagingSenderId: "330419555210"
};
firebase.initializeApp(config);

// The shared state object that any vue component can get access to.
// Has some placeholders that we’ll use further on!
export const store = {
  ballsInFeed: null,
  currentUser: null,
  writeBall: (message) => console.log(message)
};


// a reference to the Balls collection
const ballsCollection = firebase.firestore()
  .collection('balls');

// onSnapshot is executed every time the data
// in the underlying firestore collection changes
// It will get passed an array of references to
// the documents that match your query
ballsCollection
  .onSnapshot((ballsRef) => {
    const balls = [];
    ballsRef.forEach((doc) => {
      const ball = doc.data();
      ball.id = doc.id;
      balls.push(ball);
    });
    store.ballsInFeed = balls;
  });



// WEBPACK FOOTER //
// ./src/store.js